export enum Experiments {
  SEARCH_CERTIFICATE = 'search-certificate',
  ALGOLIA_SEARCH_BAR = 'algolia-search-bar',
  DISCOVERY_HOME_TOP_10 = 'discovery-home-top-10'
}
